import moment from "moment";
import { u_ } from "@pressmedia/webappbase";

function adjustDaysDataOfMonth(date, daysData, callback) {
	const firstDayOfMonth = moment.isMoment(date) ? date.clone() : moment(date);
	if( !firstDayOfMonth.isValid() ) {
		throw new TypeError("arguments[0] must be date format.");
	}
	
	if( !Array.isArray(daysData) ) {
		throw new TypeError("arguments[1] must be array.");
	}
	
	(firstDayOfMonth.date() !== 1) && firstDayOfMonth.startOf("month");
	u_.isFunction(callback) || (callback = () => {});
	
	const list = [];
	for(let i = 0; i < daysData.length; i++) {
		if(
			!u_.isObject(daysData[i]) ||
			( daysData[i].minYear && firstDayOfMonth.year() < parseInt(daysData[i].minYear) ) ||
			( daysData[i].maxYear && firstDayOfMonth.year() > parseInt(daysData[i].maxYear) )
		) {
			continue;
		}
		
		const item = { ...daysData[i] };
		
		// `day`
		if( u_.hasProperty(item, "day") ) {
			u_.isString(item.day) && ( item.day = parseInt(item.day) );
			
			if( u_.isNumber(item.day) && !isNaN(item.day) ) {
				const ym = firstDayOfMonth.format("YYYY-MM");
				const day = u_.zeroPadding(item.day, 2);
				item.day = moment(`${ym}-${day}`);
			}
			
			if( !moment.isMoment(item.day) || !item.day.isValid() ) {
				delete item.day;
			}
		}
		
		// `start`
		if( u_.hasProperty(item, "start") ) {
			if(!item.day && item.start) {
				if( u_.isString(item.start) ) {
					item.start = moment(item.start);
				} else
				if( u_.isNumber(item.start) ) {
					const ym = firstDayOfMonth.format("YYYY-MM");
					const day = u_.zeroPadding(item.start, 2);
					item.start = moment(`${ym}-${day}`);
				}
			}
			
			if( !moment.isMoment(item.start) || !item.start.isValid() ) {
				delete item.start;
			} else
			if( item.start.isAfter(firstDayOfMonth, "month") ) {
				continue;
			} else {
				item.start = item.start.format("YYYY-MM-DD");
				if( firstDayOfMonth.isAfter(item.start, "day") ) {
					item._start = firstDayOfMonth.format("YYYY-MM-DD");
				} else {
					item._start = item.start;
				}
			}
		}
		
		// `end`
		if( u_.hasProperty(item, "end") ) {
			if(item.start && item.end) {
				if( u_.isString(item.end) ) {
					item.end = moment(item.end);
				} else
				if( u_.isNumber(item.end) ) {
					const ym = firstDayOfMonth.format("YYYY-MM");
					const day = u_.zeroPadding(item.end, 2);
					item.end = moment(`${ym}-${day}`);
				}
			}
			
			if( !moment.isMoment(item.end) || !item.end.isValid() ) {
				delete item.end;
			} else
			if( item.end.isBefore(item._start, "day") ) {
				continue;
			} else {
				item.end = item.end.format("YYYY-MM-DD");
				if( firstDayOfMonth.isBefore(item.end, "month") ) {
					item._end = firstDayOfMonth.clone().endOf("month").format("YYYY-MM-DD");
				} else {
					item._end = item.end;
				}
			}
		}
		
		// calc
		if(item.day) {
			// call callback.
			if(
				callback(item.day, item) === false ||
				!moment.isMoment(item.day) ||
				!item.day.isSame(firstDayOfMonth, "month")
			) {
				continue;
			}
			
		} else
		if(item.start) {
			if(!item.end) {
				item._end = firstDayOfMonth.clone().endOf("month").format("YYYY-MM-DD");
			}
			
			item.day = moment(item._start);
			
			// call callback.
			if(
				callback(item.day, item) === false ||
				!moment.isMoment(item.day) ||
				item.day.isAfter(firstDayOfMonth, "month")
			) {
				continue;
			}
			
			if( item.day.isBefore(firstDayOfMonth, "day") ) {
				item.day = firstDayOfMonth.clone();
			}
			
			while( item.day.isBefore(item._end) ) {
				const daysIdx = item.day.days();
				const weekPos = Math.ceil(item.day.date() / 7);
				
				Array.isArray(list[weekPos]) || (list[weekPos] = []);
				Array.isArray(list[weekPos][daysIdx]) || (list[weekPos][daysIdx] = []);
				list[item.weekPos][item.daysIdx].push({ ...item, daysIdx, weekPos });
				
				item.day = item.day.clone().add(1, "days");
			}
			
		} else
		if(
			u_.isNumber(item.daysIdx) && item.daysIdx >= 0 &&
			u_.isNumber(item.weekPos) && item.weekPos > 0
		) {
			item.day = firstDayOfMonth.clone().add(
				(item.daysIdx - firstDayOfMonth.days() + 7) % 7 + (item.weekPos - 1) * 7,
				"days"
			);
			
			// call callback.
			if(
				callback(item.day, item) === false ||
				!moment.isMoment(item.day) ||
				!item.day.isSame(firstDayOfMonth, "month")
			) {
				continue;
			}
			
		} else {
			continue;
		}
		
		item.daysIdx = item.day.days();
		item.weekPos = Math.ceil(item.day.date() / 7);
		
		Array.isArray(list[item.weekPos]) || (list[item.weekPos] = []);
		Array.isArray(list[item.weekPos][item.daysIdx]) || (list[item.weekPos][item.daysIdx] = []);
		list[item.weekPos][item.daysIdx].push(item);
	}
	
	return list;
}

export default adjustDaysDataOfMonth;
